import { SystemHealth } from '@bartizo/shared';
import { apiRequest } from './client.js';

/** The central server's backups and partition maintenance (S8, S19; admins only). */
export const getSystemHealth = (): Promise<SystemHealth> =>
  apiRequest('/system/health', { schema: SystemHealth });
